import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import ClientDashboard from "@/pages/ClientDashboard";
import IntakeForm from "@/pages/IntakeForm";
import AdminLogin from "@/pages/AdminLogin";
import { AdminDashboard, AdminClientDetail } from "@/pages/Admin";
import NetWorthTracker from "@/pages/NetWorthTracker";
import Achievements from "@/pages/Achievements";

function ProtectedClient({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#5B5E5B]">Loading…</div>;
  if (!user) return <Navigate to="/" replace/>;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback/>;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing/>}/>
      <Route path="/dashboard" element={<ProtectedClient><ClientDashboard/></ProtectedClient>}/>
      <Route path="/intake" element={<ProtectedClient><IntakeForm/></ProtectedClient>}/>
      <Route path="/net-worth" element={<ProtectedClient><NetWorthTracker/></ProtectedClient>}/>
      <Route path="/achievements" element={<ProtectedClient><Achievements/></ProtectedClient>}/>
      <Route path="/admin/login" element={<AdminLogin/>}/>
      <Route path="/admin" element={<AdminDashboard/>}/>
      <Route path="/admin/clients/:user_id" element={<AdminClientDetail/>}/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter/>
        <Toaster position="top-right" richColors closeButton/>
      </BrowserRouter>
    </AuthProvider>
  );
}
